module.exports = {
	"header": "Luleå-based tech company enters a new collaboration to create a new type of e-commerce",
	"date": "2022/11/11",
	"imgSrc": "20.png",
	"imgAlt": "Luleå-based tech company enters a new collaboration to create a new type of e-commerce",
	"ingress": "By: Norrbottens Affärer (in Swedish)",
	"externalLink": "https://norrbottensaffarer.se/nyheter/lulea/artikel/luleabaserat-techbolag-i-samarbete-for-ny-e-handel/lw39q5yj"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/20/article.json
// module id = 90
// module chunks = 0